import {
    decodeDelimitedArray,
    decodeDelimitedArrayEnum,
    decodeNumber,
    EncodedQuery,
    encodeDelimitedArray,
    encodeNumber,
    objectToSearchString,
    QueryParamConfig,
} from 'use-query-params';

const StringArrayParam: QueryParamConfig<string[]> = {
    encode: array => encodeDelimitedArray(array, ','),
    decode: arrayStr => decodeDelimitedArray(arrayStr, ',') as string[],
};

const NumberArrayParam: QueryParamConfig<number[]> = {
    encode: array => encodeDelimitedArray(array.map(String), ','),
    decode: arrayStr => decodeDelimitedArray(arrayStr, ',')?.map(Number) as number[],
};

const PageParam: QueryParamConfig<number> = {
    encode: (val: number) => encodeNumber(val + 1),
    decode: (val: Parameters<typeof decodeNumber>[0]) => (decodeNumber(val) ?? 1) - 1,
};

const createEnumArrayParam = <T extends string>(
    enumValues: T[],
): QueryParamConfig<T[] | null | undefined, T[] | null | undefined> => ({
    encode: text => encodeDelimitedArray(text == null || Array.isArray(text) ? text : [text], ','),
    decode: input => decodeDelimitedArrayEnum(input, enumValues, ','),
});

const removeEmptyParams = (encodedParams: EncodedQuery) => {
    const existingParams: EncodedQuery = {};
    for (const param in encodedParams) {
        if (typeof param === 'string') {
            const value = encodedParams[param];
            if (typeof value === 'undefined') continue;
            if (typeof value === 'string' && value.length === 0) continue;
            existingParams[param] = value;
        }
    }

    return objectToSearchString(existingParams);
};

export { removeEmptyParams, createEnumArrayParam, NumberArrayParam, PageParam, StringArrayParam };
